import Valkyrie, { viMagnifyingGlass, viSpinnerThird } from "@sippy-platform/valkyrie";

import { Stack, Typography } from "@mui/material";

function Loading({ label }) {
  return (
    <Stack sx={{ textAlign: "center", pt: 8, maxWidth: 200, justifySelf: "center" }}>
      <Typography variant="h1" color="primary">
        <Valkyrie icon={viSpinnerThird} spin />
      </Typography>
      <Typography variant="h5">{label}</Typography>
    </Stack>
  );
}

function NoResults({ totalCount, icon, noItemsLabel, noResultsLabel }) {
  if (totalCount === 0) {
    return (
      <Stack sx={{ textAlign: "center", pt: 8, maxWidth: 200, justifySelf: "center" }}>
        <Typography variant="h1" color="primary">
          <Valkyrie icon={icon} />
        </Typography>
        <Typography variant="h5">{noItemsLabel}</Typography>
      </Stack>
    );
  }

  return (
    <Stack sx={{ textAlign: "center", pt: 8, maxWidth: 200, justifySelf: "center" }}>
      <Typography variant="h1" color="primary">
        <Valkyrie icon={viMagnifyingGlass} />
      </Typography>
      <Typography variant="h5">{noResultsLabel}</Typography>
    </Stack>
  );
}

export const MetaStates = { Loading, NoResults };
